import {CaracterizacaoModulo} from './caracterizacao/caracterizacao.modulo';
import {IdentificacaoModulo} from './identificacao/identificacao.modulo';
import {RecursoFisicoModulo} from './recursos-fisicos/recurso-fisico.modulo';
import {RecursoHumanoModulo} from './recursos-humanos/recurso-humano.modulo';

export class EstabelecimentoModel {

    // ====================================
    // Os campos abaixo não são do formulário, mas estou guardando para mandar de volta no rascunho quando
    // ====================================
    codigoRascunho: number;
    codigoUnidade: string;
    tipoPessoaJuridica: string;
    cnes: string;
    status: string;
    tipoGestao: string;
    motivoDesabilitado: string;
    codigoDistritoAdministrativo: string;
    // ====================================


    identificacao: IdentificacaoModulo = new IdentificacaoModulo();
    caracterizacao: CaracterizacaoModulo = new CaracterizacaoModulo();
    recursoFisico: RecursoFisicoModulo = new RecursoFisicoModulo();
    recursoHumano: RecursoHumanoModulo = new RecursoHumanoModulo();

    constructor(rascunho: any, codigoRascunho: number, resultadoEndereco: any, flag = 'identificacao') {
        // console.log('rascunho:', JSON.stringify(rascunho));
        this.codigoRascunho = codigoRascunho;
        // tslint:disable-next-line:triple-equals
        if ( flag == 'identificacao') {
            this.variaveisControleEstabelecimento(rascunho);
            this.rascunhoParaEstabelecimento(rascunho, resultadoEndereco);
        }
        // tslint:disable-next-line:triple-equals
        if ( flag == 'caracterizacao-geral') {
            this.variaveisControleEstabelecimento(rascunho);
            this.caracterizacaoGeral(rascunho);
        }
    }

    private variaveisControleEstabelecimento(rascunho: any) {
        // tslint:disable-next-line:max-line-length
        this.codigoUnidade = rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.codigoUnidade ? rascunho.estabelecimentoSaude.codigoUnidade : '0' : '0';
        // tslint:disable-next-line:max-line-length
        this.tipoPessoaJuridica = rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.tipoPessoaJuridica ? rascunho.estabelecimentoSaude.tipoPessoaJuridica : '' : '';
        this.cnes = rascunho ? rascunho.cnes ? rascunho.cnes : '' : '';
        this.status = rascunho ? rascunho.status ? rascunho.status : '' : '';
        // tslint:disable-next-line:max-line-length
        this.tipoGestao = rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.tipoGestao ? rascunho.estabelecimentoSaude.tipoGestao : '' : '';
        // tslint:disable-next-line:max-line-length
        this.motivoDesabilitado = rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.motivoDesabilitado ? rascunho.estabelecimentoSaude.motivoDesabilitado : '' : '';
        // tslint:disable-next-line:max-line-length
        this.codigoDistritoAdministrativo = rascunho.estabelecimentoSaude ? rascunho.estabelecimentoSaude.codigoDistritoAdministrativo ? rascunho.estabelecimentoSaude.codigoDistritoAdministrativo : '' : '';
    }

    private rascunhoParaEstabelecimento(rascunho: any, resultadoEndereco: any) {
        // console.log('rascunhoParaEstabelecimento: ', rascunho);
        this.identificacao.rascunhoParaIdentificacao(rascunho, resultadoEndereco);
        this.caracterizacao.rascunhoParaCaracterizacao(rascunho);
        this.recursoFisico.rascunhoParaRecursoFisico(rascunho);
        this.recursoHumano.rascunhoParaRecursoHumano(rascunho);
    }

    private caracterizacaoGeral(rascunho: any) {
        this.caracterizacao.rascunhoParaCaracterizacaoGeral(rascunho);
    }
}
